'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import ServiceHeader from './components/header';
import ServiceLayout from './components/showcase-layout';
import { gsap, ScrollTrigger } from '@/lib/gsap';
import Container from '@/components/layouts/container';
const Services = () => {
  const $ = _c(3);
  const containerRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      gsap.set(containerRef.current, {
        backgroundColor: "#37353E"
      });
      ScrollTrigger.create({
        trigger: containerRef.current,
        start: "top top",
        end: "+=100%",
        onLeave: () => {
          gsap.to(containerRef.current, {
            backgroundColor: "white",
            duration: 0.6,
            ease: "power3.out"
          });
        },
        onEnterBack: () => {
          gsap.to(containerRef.current, {
            backgroundColor: "#37353E",
            duration: 0.6,
            ease: "power3.out"
          });
        }
      });
    };
    t1 = {
      scope: containerRef
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useGSAP(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div id="services" ref={containerRef}><Container className="min-h-screen py-16 pb-32"><ServiceHeader /><ServiceLayout /></Container></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default Services;